




































import Vue from 'vue';
import ISkillEffect from '@/models/skills/ISkillEffect';
import ISkillEffectValue from '@/models/skills/ISkillEffectValue';
import ISkillLevel from '@/models/skills/ISkillLevel';
import { describeBlowValue } from '@/models/skills/blows/registry';
import { IBlowDescription } from '@/models/skills/blows/types';
import { collectSpans, collectStateVfxIds } from '@/models/skills/blows/spans';
import BlowSegments from './BlowSegments.vue';
import RawParams from './RawParams.vue';
import StateEffect from '@/components/skill/StateEffect.vue';

const APPLY_LABELS: { [k: number]: string } = {
    0: 'caster',
    1: 'target(s)',
    2: 'all affected',
    3: 'enemies',
    4: 'allies',
};

export default Vue.extend({
    name: 'SkillEffectCard',
    components: {
        BlowSegments,
        RawParams,
        StateEffect,
    },
    props: {
        effect: {
            type: Object as () => ISkillEffect,
            required: true,
        },
        value: {
            type: Object as () => ISkillEffectValue | null,
            default: null,
        },
        forceShow: {
            type: Boolean as () => boolean,
            default: false,
        },
        activeRankData: {
            type: Object as () => ISkillLevel,
        },
    },
    computed: {
        desc(): IBlowDescription | null {
            if (!this.value) {
                return null;
            }
            return describeBlowValue(
                this.effect.effectClass,
                this.value.value,
                this.value.duration,
                this.effect.effectApplyType,
            );
        },
        isKnown(): boolean {
            return !!(this.desc && this.desc.known);
        },
        spans(): Array<[number, number]> {
            if (this.desc && this.desc.segments) {
                return collectSpans(this.desc.segments);
            }
            return [];
        },
        vfxIds(): number[] {
            if (this.desc && this.desc.segments) {
                return collectStateVfxIds(this.desc.segments);
            }
            return [];
        },
        title(): string {
            if (this.desc && this.desc.known) {
                return this.desc.name;
            }
            return `Effect ${this.effect.effectClass}`;
        },
        applyLabel(): string {
            return APPLY_LABELS[this.effect.effectApplyType] || String(this.effect.effectApplyTypeStr);
        },
        display(): boolean {
            if (this.forceShow) {
                return true;
            }
            // preserved from SkillEffect.vue: hide null-effect (class 0) slots
            return !(this.effect.effectClass === 0
                && (!!this.value && (!!this.value.value || this.value.value === '')));
        },
    },
});
